module.exports = __webpack_public_path__ + "static/media/aws-member.866c0164.png";